import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const icon = css`
  width: 22px;
  height: 22px;
  border: 4px solid ${colors.white.DEFAULT};
  background: ${colors.white.DEFAULT};
  box-shadow: 0px 1px 10px ${colors.black.a5};
  box-sizing: content-box;
  border-radius: 50%;
  cursor: pointer;
`;

export const endCarIcon = css`
  cursor: pointer;
`;
